import React from "react";

export default (props) => (
  <div
    id={props.id}
    class={`${props.responsive ? "table-responsive" : ""} ${props.border ? "table-bordered" : ""}`}
    style={{
      display: "flex",
      overflowX: props.scrollX || "auto",
      maxHeight: props.maxHeight || "80vh",
      height: props.height,
      minHeight: props.minHeight,
      minWidth: props.minWidth,
      maxWidth: props.maxWidth,
      overflowY: "auto",
      fontSize: props.fontSize,
      borderRadius: props.borderRadius,
      padding: props.padding,
    }}
  >
    <table
      className={`table table-hover ${props.tableBordered ? "table-bordered" : ""}`}
    >
      {props.children}
    </table>
  </div>
);
